
export default {
  props: ['show'],
  data() {
    return {}
  },
  methods: {
    /**
     * metodo que vuelve a recarga la pagina si se presenta un error en la carga de las configuraciones
     */
    reload() {
      location.reload()
    }
  }
}
